import { Component, OnInit, ViewChild } from '@angular/core';
import { routes } from '@app/consts';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import moment from 'moment';
import { ToilBalanceReportService } from './services/toil-balance-report.service';
import { from } from 'rxjs';
import { GridState } from '@app/shared/services/grid-state/grid-state.model';

@Component({
    selector: 'app-toil-balance-report',
    templateUrl: './toil-balance-report.component.html',
    styleUrls: ['./toil-balance-report.component.scss']
})
export class ToilBalanceReportComponent implements OnInit {
    @ViewChild('excelexport') excelexport: any;
    public grid: GridComponent;
    public routes: typeof routes = routes;
    public bindingType = 'array';
    public gridDataResult: GridDataResult;
    excelData: any;
    gridId: string = 'ToilBalanceReportDataGrid';
    isLoading: boolean;
    pageSize: number = 20;
    skip: number = 0;

    sortString: string;
    filterString: string;

    excelColumns: any[] = [
        {field: 'employeeName', title: this.translate.instant('ToilBalance-EmployeeName')},
        {field: 'managerName', title: this.translate.instant('ToilBalance-ManagerName')},
        {field: 'toilPolicyName', title: this.translate.instant('ToilBalance-PolicyName')},
        {field: 'outstandingBalance', title: this.translate.instant('ToilBalance-OutstandingBalance')},
    ];

    public columns: any[] = [
        {field: 'employeeName', title: this.translate.instant('ToilBalance-EmployeeName'), dataType: 'String' , localizationCode: 'ToilBalance-EmployeeName' },
        {field: 'managerName', title: this.translate.instant('ToilBalance-ManagerName'), dataType: 'String', localizationCode: 'ToilBalance-EmployeeName'},
        {field: 'toilPolicyName', title: this.translate.instant('ToilBalance-PolicyName'), dataType: 'String', localizationCode: 'ToilBalance-PolicyName'},
        {field: 'outstandingBalance', title: this.translate.instant('ToilBalance-OutstandingBalance'), dataType: 'Number', localizationCode: 'ToilBalance-OutstandingBalance'},
    ];

    sortableColumns: any[] = [
        // { field: 'employeeName', sortValue: 'employeeName' },
        // { field: 'toilPolicyName', sortValue: 'toilPolicyName' },
    ];

    filterCategories: any[] = [
        { field: "employeeName", title: this.translate.instant('ToilBalance-EmployeeName'), type: "String", dataType: 'String' },
        { field: "toilPolicyName", title: this.translate.instant('ToilBalance-PolicyName'), type: "String", dataType: 'String' },
    ];

    searchValue: any;
    searchFilterString: string;
    getRequest: any;
    error: boolean;
    showAsOfDateField: boolean = true;
    asOfDate: any = moment().format('YYYY-MM-DD');
    fileName: string = this.translate.instant('TimeOffBuySellHoursReport') + '_' + moment().format('YYYY-MM-DD') + '.xlsx';
    filterToggleDetails: {
        text: string,
        checked: boolean
    } = {
        text: this.translate.instant('FilterInactiveEmployees'),
        checked: true
    }

    constructor(
        private translate: TranslateService,
        private overlayService: OverlayService,
        private toilBalanceReportService: ToilBalanceReportService,
    ) {
        this.getData();

        // Bind 'this' explicitly to capture the execution context of the component.
        this.allData = this.allData.bind(this);
    }

    ngOnInit(): void {
    }

    public allData() {
        this.overlayService.show('Loading');

        let filter = ``;
        if (this.filterString) {
            filter += ` AND (${this.filterString})`;
        }

        from(this.toilBalanceReportService.getAllToilBalanceReportData(filter, this.sortString, this.asOfDate, this.filterToggleDetails.checked))
            .subscribe({
                next: (res) => {
                    this.excelData = res.data;

                    // if I dont have this timeout first time I download the report the data will be blank
                    setTimeout(() => {
                        this.excelexport.save();
                    }, 1000);
                },
                error: (e) => {
                    this.overlayService.hide();
                },
                complete: () => this.overlayService.hide()
            });
    }

    getData(): void {
        this.isLoading = true;

        let filter = ``;
        if (this.filterString) {
            filter += ` AND (${this.filterString})`;
        }

        this.getRequest = this.toilBalanceReportService.getToilBalanceReportData(this.pageSize, this.skip, filter, this.sortString, this.asOfDate, this.filterToggleDetails.checked)
            .subscribe(
                {
                    next: (v) => {
                        this.gridDataResult = {
                            data: v.data,
                            total: v.total,
                        }
                    },
                    error: (e) => {
                        this.error = true;
                        this.isLoading = false;
                    },
                    complete: () => this.isLoading = false
                }
            );
    }

    gridStateChange(gridState: GridState) {
        if (this.pageSize !== gridState.pageSize) {
            this.pageSize = gridState.pageSize;
        }
        if (this.skip !== gridState.skip) {
            this.skip = gridState.skip;
        }
        if (this.sortString !== gridState.sortString) {
            this.sortString = gridState.sortString;
        }
        if (this.filterString !== gridState.filter) {
            this.filterString = gridState.filter;
            this.skip = 0;
        }
        if (this.asOfDate !== gridState.asOfDate) {
            this.asOfDate = gridState.asOfDate;
        }
        if (this.filterToggleDetails.checked !== gridState.filterToggleDetails.checked) {
            this.filterToggleDetails.checked = gridState.filterToggleDetails.checked;
        }

        this.getRequest.unsubscribe();
        this.getData();
    }
}
